import { Popover, Tag } from "antd";
import { Link } from "react-router-dom";
import React from "react";
import config from "@/config";
import {MapPin} from "lucide-react";
import {BiSolidBusiness} from "react-icons/bi";

export const JobCard = ({ index, job }) => {
    const popOverContent = (key) => {
        return (
            <div className="container mx-auto p-2 bg-white max-w-md">

                {/* Header Section */}
                <div className="flex items-center mb-4">
                    <img
                        src={"/" + key.PhotoCompany}
                        alt="company-logo"
                        className="rounded-lg w-16 h-16 mr-4 border border-gray-100"
                    />
                    <div>
                        <h2 className="text-lg font-bold">{key.JobTitle}</h2>
                        <p className="text-sm text-gray-600">{key.JobCompanyName}</p>
                    </div>
                </div>

                {/* Job Details Section */}
                <div className="mb-4">
                    <div className="flex items-center text-gray-600 text-sm space-x-4">
                        <Tag color="blue">{job.PlaceWork || "Liên hệ"}</Tag>
                        <Tag color="green">{job.JobSalary ? /^\d+$/.test(job.JobSalary) ? config.webConfig.getCurrency(job.JobSalary) : job.JobSalary : "Thỏa thuận"}</Tag>
                        <Tag color="orange">
                            {job.ngheNghiep || "Công nhân"}
                        </Tag>
                    </div>
                </div>

                {/* Job Description */}
                <div className="mb-4 max-h-48 overflow-y-auto">
                    <h3 className="text-md font-bold mb-2">Mô tả công việc</h3>
                    <p className="text-sm text-gray-700">{key.Description}</p>
                </div>

            </div>
        );
    };

    return (
        <Popover placement={"right"} content={popOverContent(job)} key={index} mouseEnterDelay={0.5}>
            <Link
                to={config.routes.job + `/${job.Pk}`}
                key={index}
                className="grid relative grid-cols-5 h-full items-center border border-gray-200 hover:border-primary-hover hover:bg-green-100 hover:text-primary-hover p-2 rounded-lg hover:shadow-lg hover:cursor-pointer"
                style={{
                    padding: "0",
                }}
            >
                {/* Hình ảnh */}
                <div className="col-span-1 lg:mb-0 mb-20 p-2">
                    <img
                        src={'/' + job.PhotoCompany}
                        alt="company-logo"
                        className="rounded-lg lg:w-full w-42"
                    />
                </div>

                {/* Nội dung */}
                <div className="col-span-4 p-2 flex flex-col justify-between w-full">
                    <h2 className="text-lg font-bold lg:whitespace-normal whitespace-nowrap overflow-ellipsis overflow-hidden hover:underline">{job.JobTitle}</h2>
                    <p className="text-gray-500">{job.JobCompanyName}</p>
                    <div className="flex gap-2 my-2 flex-wrap">
                        <Tag color="blue">{job.PlaceWork || "Liên hệ"}</Tag>
                        <Tag color="green">{job.JobSalary ? /^\d+$/.test(job.JobSalary) ? config.webConfig.getCurrency(job.JobSalary) : job.JobSalary : "Thỏa thuận"}</Tag>
                        <Tag color="orange">
                            {job.ngheNghiep || "Công nhân"}
                        </Tag>
                    </div>
                </div>
            </Link>
        </Popover>
    );
}